import { createPolymorphicComponent } from '@mantine/core'

/**
 * Create a button component with the given element type
 */
export const createButton = <T>(
  element: Parameters<typeof createPolymorphicComponent<'button', T>>[0]
) => createPolymorphicComponent<'button', T>(element)
